// @ts-nocheck

import { EmailTemplateService } from './emailTemplateService';
import {
  useMutationEngine,
  useNewQueryEngine,
} from '../../../../queries/useDataEngine';
import { EMPTY_OBJECT } from '../../../../const/CommonConst';

const EMAIL_TEMPLATE = 'emailTemplate';

export const EMAIL_TEMPLATE_QUERY_KEYS = {
  ALL: [EMAIL_TEMPLATE],

  emailTemplateList: {
    ROOT: [EMAIL_TEMPLATE, 'list'],
    key: (params = {}) => [EMAIL_TEMPLATE, 'list', params],
  },

  emailTemplateTags: {
    ROOT: [EMAIL_TEMPLATE, 'tags'],
    key: (params = {}) => [EMAIL_TEMPLATE, 'tags', params],
  },

  emailTemplateFilterOptions: {
    ROOT: [EMAIL_TEMPLATE, 'filterOptions'],
    key: (params = {}) => [EMAIL_TEMPLATE, 'filterOptions', params],
  },

  singleEmailTemplate: {
    ROOT: [EMAIL_TEMPLATE, 'single'],
    key: (params = {}) => [EMAIL_TEMPLATE, 'single', params],
  },

  emailTemplateFilterList: {
    ROOT: [EMAIL_TEMPLATE, 'filteredList'],
    key: (params = {}) => [EMAIL_TEMPLATE, 'filteredList', params],
  },
};

export const useEmailTemplateListQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    EMAIL_TEMPLATE_QUERY_KEYS.emailTemplateList.key,
    EmailTemplateService.getEmailTemplate,
    params,
    options
  );

export const useEmailTemplateTagsQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    EMAIL_TEMPLATE_QUERY_KEYS.emailTemplateTags.key,
    EmailTemplateService.getEmailTemplateTags,
    params,
    options
  );

export const useCreateEmailTemplateMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(EmailTemplateService.createEmailTemplate, {
    ...options,

    invalidateQueries: [EMAIL_TEMPLATE_QUERY_KEYS.emailTemplateList.ROOT],
  });
};

export const useUpdateEmailTemplateMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(EmailTemplateService.updateEmailTemplate, {
    ...options,

    invalidateQueries: [EMAIL_TEMPLATE_QUERY_KEYS.ALL],
  });
};

export const useRemoveEmailTemplateMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(EmailTemplateService.removeEmailTemplate, {
    ...options,

    invalidateQueries: [EMAIL_TEMPLATE_QUERY_KEYS.emailTemplateList.ROOT],
  });
};

export const useEmailTemplateFilterOptionsQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    EMAIL_TEMPLATE_QUERY_KEYS.emailTemplateFilterOptions.key,
    EmailTemplateService.getEmailTemplateFilterOptions,
    params,
    options
  );

export const useSingleEmailTemplateQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    EMAIL_TEMPLATE_QUERY_KEYS.singleEmailTemplate.key,
    EmailTemplateService.getSingleEmailTemplate,
    params,
    options
  );

export const useFilterEmailTemplatesQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    EMAIL_TEMPLATE_QUERY_KEYS.emailTemplateFilterList.key,
    EmailTemplateService.filterEmailTemplates,
    params,
    options
  );

export const useExportEmailTemplateMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useMutationEngine(EmailTemplateService.exportEmailTemplates, {
    ...options,
  });
